export default __webpack_public_path__ + "a944225b5145acb3d230645d716a9061.png";